import React from 'react';
import {
  Card,
  Col,
  Row,
} from "react-bootstrap";
import moment from 'moment';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactPaginate from 'react-paginate';
import { useSelector, useDispatch } from 'react-redux';
import { getCtasList, createCta, updateCta, deleteCta } from "../../actions/ctas";
import CtaItem from '../../components/settings/CtaItem';
import CreateCtaForm from '../../components/settings/CreateCtaForm';
import './CTA.scss';

const ReactSwal = withReactContent(Swal);
const ITEMS_PER_PAGE = 5;

const CTA = props => {
  const [pageCount, setPageCount] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(0);
  const userInfo = useSelector(({ settings }) => settings.userInfo);
  const ctaList = useSelector(({ settings }) => 
    (settings.ctas || [])
      .filter(ct => !ct.deletedAt)
      .sort((a, b) => {
        if (moment(a.createdAt).isAfter(moment(b.createdAt))) {
          return 1;
        }

        if (moment(a.createdAt).isBefore(moment(b.createdAt))) {
          return -1;
        }
      })
  );

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (userInfo.userId) {
      dispatch(getCtasList(userInfo.type));
    }
  }, []);

  React.useEffect(() => {
    const newPageCount = Math.ceil(ctaList.length / ITEMS_PER_PAGE);
    setPageCount(newPageCount);

    if (currentPage >= newPageCount && newPageCount !== 0) {
      setCurrentPage(newPageCount - 1);
    }
  }, [ctaList]);

  const onClickAddCta = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <CreateCtaForm
          onClose={ReactSwal.clickCancel}
          userInfo={userInfo}
          onSubmit={onCreateCtaItem}
        />
      )
    })
    .then(result => {
      if (result.value) {
      }
    });
  };

  const onCreateCtaItem = (data) => {
    dispatch(createCta(data));
  }

  const onEditCtaItem = (data) => {
    dispatch(updateCta(data.id, data));
  }

  const handlePageClick = data => {
    setCurrentPage(data.selected);
  };

  const onDeleteCtaItem = (id) => {
    dispatch(deleteCta(id));
  };

  const onClickEditCta = (id) => {
    const selCta = ctaList.find(ct => ct.id === id);

    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <CreateCtaForm
          onClose={ReactSwal.clickCancel}
          userInfo={userInfo}
          item={selCta}
          onSubmit={onEditCtaItem}
          isEditing
        />
      )
    })
    .then(result => {
      if (result.value) {
      }
    });
  };

  return (
    <div className="cta-container">
      <Row className="full-width">
        <Col>
          <Row className="full-width">
            <Card bg="light" className="full-width full-height">
              <Card.Header>Call to Action</Card.Header>
              <Card.Body>
                <div>
                  A call to action (CTA) is used in sites and with items to prompt the user to take the next action. Here, you can define CTAs that are used across the application.
                </div>
                <div className="add-cta-button" onClick={onClickAddCta}>
                  +
                </div>
                <div className="cta-items-list">
                  {
                    ctaList
                      .filter((key, idx) => {
                        if (currentPage * ITEMS_PER_PAGE <= idx && (currentPage + 1) * ITEMS_PER_PAGE > idx) {
                          return true;
                        }

                        return false;
                      })
                      .map((cta, idx) => (
                        <CtaItem
                          key={cta.id}
                          avatar={cta.imageUrl}
                          userInfo={userInfo}
                          data={cta}
                          onDelete={() => onDeleteCtaItem(cta.id)}
                          onEdit={() => onClickEditCta(cta.id)}
                        />
                      ))
                  }
                </div>
                {ctaList.length > ITEMS_PER_PAGE && (
                  <div className="pagination-container">
                    <ReactPaginate
                      previousLabel={'<'}
                      nextLabel={'>'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={'pagination'}
                      subContainerClassName={'pages pagination'}
                      activeClassName={'active'}
                      forcePage={currentPage}
                    />
                  </div>
                )}
              </Card.Body>
            </Card>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default CTA;
